var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5005 7.50012C22.5005 6.2577 21.4927 5.25049 20.2502 5.25049C16.6177 5.25049 7.38251 5.25049 3.75005 5.25049C2.50751 5.25049 1.49976 6.2577 1.49976 7.50012C1.49976 9.80575 1.49976 14.1946 1.49976 16.5002C1.49976 17.7426 2.50751 18.7499 3.75005 18.7499C7.38251 18.7507 16.6177 18.7507 20.2502 18.7507C21.4927 18.7499 22.5005 17.7426 22.5005 16.5002V7.50012ZM20.9997 7.50012C20.9997 7.08571 20.6643 6.75051 20.2502 6.75051C16.6177 6.75051 7.38251 6.75051 3.75005 6.74971C3.33587 6.75051 3.00047 7.08571 3.00047 7.50012C3.00047 9.80575 3.00047 14.1946 3.00047 16.5002C3.00047 16.9146 3.33587 17.2498 3.75005 17.2498C7.38251 17.2506 16.6177 17.2506 20.2502 17.2506C20.6643 17.2498 20.9997 16.9146 20.9997 16.5002V7.50012Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.750009V23.2503C18 23.6643 18.336 24.0003 18.75 24.0003C19.164 24.0003 19.5 23.6643 19.5 23.2503V0.750009C19.5 0.336004 19.164 0 18.75 0C18.336 0 18 0.336004 18 0.750009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 1.50002H21.75C22.164 1.50002 22.5 1.16401 22.5 0.750009C22.5 0.336004 22.164 0 21.75 0H15.75C15.336 0 15 0.336004 15 0.750009C15 1.16401 15.336 1.50002 15.75 1.50002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 24.0003H21.75C22.164 24.0003 22.5 23.6643 22.5 23.2503C22.5 22.8363 22.164 22.5003 21.75 22.5003H15.75C15.336 22.5003 15 22.8363 15 23.2503C15 23.6643 15.336 24.0003 15.75 24.0003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21776 10.7218L4.7219 12.2177C4.42908 12.5105 4.42908 12.9855 4.7219 13.2783C5.01471 13.5711 5.48965 13.5711 5.78247 13.2783L7.27833 11.7824C7.57115 11.4896 7.57115 11.0146 7.27833 10.7218C6.98552 10.429 6.51058 10.429 6.21776 10.7218Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27831 12.2178L5.78244 10.7219C5.48963 10.4291 5.01469 10.4291 4.72188 10.7219C4.42906 11.0147 4.42906 11.4897 4.72188 11.7825L6.21774 13.2784C6.51056 13.5712 6.98549 13.5712 7.27831 13.2784C7.57113 12.9856 7.57113 12.5106 7.27831 12.2178Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7178 10.722L9.2219 12.2179C8.92908 12.5107 8.92908 12.9857 9.2219 13.2785C9.51471 13.5713 9.98965 13.5713 10.2825 13.2785L11.7783 11.7826C12.0711 11.4898 12.0711 11.0148 11.7783 10.722C11.4855 10.4292 11.0106 10.4292 10.7178 10.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7783 12.2181L10.2824 10.7222C9.98963 10.4293 9.51469 10.4293 9.22188 10.7222C8.92906 11.015 8.92906 11.4899 9.22188 11.7828L10.7177 13.2786C11.0106 13.5715 11.4855 13.5715 11.7783 13.2786C12.0711 12.9858 12.0711 12.5109 11.7783 12.2181Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2178 10.7221L13.7219 12.218C13.4291 12.5108 13.4291 12.9858 13.7219 13.2786C14.0147 13.5714 14.4897 13.5714 14.7825 13.2786L16.2783 11.7827C16.5711 11.4899 16.5711 11.0149 16.2783 10.7221C15.9855 10.4293 15.5106 10.4293 15.2178 10.7221Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2783 12.2179L14.7824 10.722C14.4896 10.4292 14.0147 10.4292 13.7219 10.722C13.4291 11.0149 13.4291 11.4898 13.7219 11.7826L15.2177 13.2785C15.5106 13.5713 15.9855 13.5713 16.2783 13.2785C16.5711 12.9857 16.5711 12.5108 16.2783 12.2179Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_1115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChange);
export default __webpack_public_path__ + "static/media/password-change.9b114562800c66f06ec4d341afedbcda.svg";
export { ForwardRef as ReactComponent };